import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__section flex-1" }
const _hoisted_2 = { class: "BaseItemDialog__section-header bg-white q-mb-12" }
const _hoisted_3 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_4 = { class: "BaseItemDialog__section-body flex column no-wrap" }
const _hoisted_5 = { class: "q-px-sm flex no-wrap items-start justify-between" }
const _hoisted_6 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_7 = { class: "flex column no-wrap items-end" }
const _hoisted_8 = { class: "fs-15px text-cool-gray-100 text-right" }
const _hoisted_9 = { class: "fs-13px text-space-b-100" }

import translate from 'src/common/helpers/language/translate'
import { IItemView } from 'src/common/interfaces'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  item: IItemView
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogItemType' },
  __name: 'BaseItemDialogItemType',
  props: {
    item: {}
  },
  setup(__props: any) {




const { t: globalT } = translate(globalTranslateObject)

const itemKinds: Record<number, string> = {
  0: globalT('item_kinds.goods_for_sale'),
  1: globalT('item_kinds.services'),
  2: globalT('item_kinds.menu_item'),
  3: globalT('item_kinds.supplies'),
  4: globalT('item_kinds.bundle_deals'),
}

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(globalT)('item_type')), 1 /* TEXT */),
      _createVNode(_component_k_divider, { size: "md" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(globalT)('item_types')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.item.item_type_str), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_9, _toDisplayString(itemKinds[__props.item.item_kind] ?? ''), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}
}

})